<template>
    <div>
        <div class="chooseBar">
            <div class="barItem" @click="chooseItem=1;$store.state.search.targetType = 'draw';draw(1)">
                <img v-if="chooseItem==1" class="barIcon" src="~@/assets/map_icons/矩形.png">
                <img v-if="chooseItem!=1" class="barIcon" src="~@/assets/map_icons/矩形未选中.png">
                <div :class="chooseItem==1 ? 'barTextChoose' : 'barText'">绘制矩形</div>
            </div>
            <div class="deliverLine"></div>
            <div class="barItem" @click="chooseItem=2;$store.state.search.targetType = 'draw';draw(2)">
                <img v-if="chooseItem==2" class="barIcon" src="~@/assets/map_icons/多边形.png">
                <img v-if="chooseItem!=2" class="barIcon" src="~@/assets/map_icons/多边形未选中.png">
                <div :class="chooseItem==2 ? 'barTextChoose' : 'barText'">绘制多边形</div>
            </div>
            <div class="deliverLine"></div>
            <div class="barItem" @click="chooseItem=3;$store.state.search.targetType = 'china';">
                <img v-if="chooseItem==3" class="barIcon" src="~@/assets/map_icons/区域.png">
                <img v-if="chooseItem!=3" class="barIcon" src="~@/assets/map_icons/区域未选中.png">
                <div :class="chooseItem==3 ? 'barTextChoose' : 'barText'">选择行政区域</div>
            </div>
            <div class="deliverLine"></div>
            <div class="barItem" @click="chooseItem=4;$store.state.search.targetType = 'upload';">
                <img v-if="chooseItem==4" class="barIcon" src="~@/assets/map_icons/上传.png">
                <img v-if="chooseItem!=4" class="barIcon" src="~@/assets/map_icons/上传未选中.png">
                <div :class="chooseItem==4 ? 'barTextChoose' : 'barText'">上传矢量</div>
            </div>
        </div>
        <div v-if="chooseItem==3" class="regionBox">
            <div style="width: 118px;margin-top: 28px;margin-right: 11px;">
                <v-autocomplete
                        ref="chinaProvince"
                        class="ma-0 mr-2"
                        :items="chinaProvinceItems"
                        item-text="areaName"
                        item-value="areaId"
                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.province')"
                        v-model="chinaProvinceNow"
                        outlined
                        dark
                        dense
                ></v-autocomplete>
            </div>
            <div style="width: 118px;margin-top: 28px;margin-right: 11px;">
                <v-autocomplete
                        ref="chinaCity"
                        class="ma-0 mr-2"
                        :disabled="!chinaProvinceNow"
                        :items="chinaCityItems"
                        item-text="areaName"
                        item-value="areaId"
                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.city')"
                        v-model="chinaCityNow"
                        outlined
                        dark
                        dense
                ></v-autocomplete>
            </div>
            <div style="width: 118px;margin-top: 28px;">
                <v-autocomplete
                        ref="chinaCounty"
                        class="ma-0"
                        :disabled="!chinaCityNow"
                        :items="chinaCountyItems"
                        item-text="areaName"
                        item-value="areaId"
                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.county')"
                        v-model="chinaCountyNow"
                        outlined
                        dark
                        dense
                ></v-autocomplete>
            </div>
        </div>
        <div v-if="chooseItem==4" class="uploadBox">
            <img @click="chooseItem=0;" src="~@/assets/images/关闭.png" style="position: absolute;top: 10px;right: 10px;cursor: pointer;z-index:1;">
            <SearchUploadFiles />
        </div>
        <div v-if="drawFinished==true" class="clearBtn" @click="clearAll()">
            <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/清除按钮.png" style="position: absolute;top: 15px;left: 22px;width:15px;height:15px;">
            <div class="clearBtnText">清除</div>
        </div>
    </div>
</template>

<script>
    import L from 'leaflet'
    import SearchUploadFiles from './SearchUploadFiles'
    import SearchPointSelector from './SearchPointSelector'
    import circle from 'turf-circle'
    import destination from 'turf-destination'
    import point from 'turf-point'
    import area from 'turf-area'
    import * as turf from "turf";
    import lineDistance from 'turf-line-distance'

    export default {
        name: "SearchRangeSelector",
        inject:['Search'],
        
        components: {
            SearchUploadFiles,
            // SearchPointSelector,
        },
        data (){
          return {
              parentContainer: '',
              markerDraw: '',
              polylineDraw: '',
              polygonDraw: '',
              rectangleDraw: '',
              pointList:[
                  {lat:'',lng:''},
                  {lat:'',lng:''},
                  {lat:'',lng:''},
              ],
              current: 0,
              dmsShow: false,
              type: 0,
              areaType: 0,
              internal: 0,
              valid:false,
              valid1:false,
              valid2:false,
              longitude:'',
              latitude:'',
              centerLongitude2:'',
              centerLatitude2:'',
              centerRadius: '',
              centerLongitude1:'',
              centerLatitude1:'',
              centerLength: '',
              centerWidth: '',
              leftUpLongitude:'',
              leftUpLatitude:'',
              rightDownLongitude:'',
              rightDownLatitude:'',
              chinaProvinceNow: '',
              chinaCityNow: '',
              chinaCountyNow: '',
              chinaProvinceItems:[],
              chinaCityItems:[],
              chinaCountyItems:[],
              countryNow: '',
              countryItems:[],
              chooseItem:0,
              drawFinished:false
          }
        },
        methods: {
            setTipByLang(){
                if(this.lang == 'zhHans'){
                    L.drawLocal = {
                        draw: {
                            handlers: {
                                marker: {
                                    tooltip: {
                                        start: '点击地图选择目标点 按Esc取消'
                                    }
                                },
                                polygon: {
                                    tooltip: {
                                        start: '点击开始绘制多边形 按Esc取消绘制',
                                        cont: '点击继续绘制多边形 按Esc取消绘制',
                                        end: '点击初始点结束绘制多边形 按Esc取消绘制'
                                    }
                                },
                                polyline: {
                                    error: '<strong>Error:</strong> shape edges cannot cross!',
                                    tooltip: {
                                        start: '点击开始绘制线 按Esc取消绘制',
                                        cont: '点击继续绘制线 按Esc取消绘制',
                                        end: '点击最终点结束绘制线 按Esc取消绘制'
                                    }
                                },
                                rectangle: {
                                    tooltip: {
                                        start: '点击并拖动绘制矩形 按Esc取消绘制'
                                    }
                                },
                                simpleshape: {
                                    tooltip: {
                                        end: '松开鼠标结束绘制'
                                    }
                                }
                            }
                        }
                    }
                } else {
                    L.drawLocal = {
                        draw: {
                            handlers: {
                                circle: {
                                    tooltip: {
                                        start: 'Click and drag to draw circle.'
                                    },
                                    radius: 'Radius'
                                },
                                circlemarker: {
                                    tooltip: {
                                        start: 'Click map to place circle marker.'
                                    }
                                },
                                marker: {
                                    tooltip: {
                                        start: 'Click map to place marker.'
                                    }
                                },
                                polygon: {
                                    tooltip: {
                                        start: 'Click to start drawing shape.',
                                        cont: 'Click to continue drawing shape.',
                                        end: 'Click first point to close this shape.'
                                    }
                                },
                                polyline: {
                                    error: '<strong>Error:</strong> shape edges cannot cross!',
                                    tooltip: {
                                        start: 'Click to start drawing line.',
                                        cont: 'Click to continue drawing line.',
                                        end: 'Click last point to finish line.'
                                    }
                                },
                                rectangle: {
                                    tooltip: {
                                        start: 'Click and drag to draw rectangle.'
                                    }
                                },
                                simpleshape: {
                                    tooltip: {
                                        end: 'Release mouse to finish drawing.'
                                    }
                                }
                            }
                        }
                    }
                }
                this.markerDraw = new L.Draw.Marker(this.parentContainer.$refs.map.mapObject)
                this.polygonDraw = new L.Draw.Polygon(this.parentContainer.$refs.map.mapObject, {
                    showArea: false,
                    allowIntersection: false,
                    shapeOptions: {
                        color: '#00BCD4',
                        fillOpacity: 0.1,
                        weight: 2
                    },
                })
                this.rectangleDraw = new L.Draw.Rectangle(this.parentContainer.$refs.map.mapObject, {
                    showArea: false,
                    allowIntersection: false,
                    shapeOptions: {
                        color: '#00BCD4',
                        fillOpacity: 0.1,
                        weight: 2
                    },
                })
                this.polylineDraw = new L.Draw.Polyline(this.parentContainer.$refs.map.mapObject, {
                    showArea: false,
                    allowIntersection: false,
                    shapeOptions: {
                        color: '#00BCD4',
                        fillOpacity: 0.1,
                        weight: 2
                    },
                })
            },
            // Search() {
            //     this.parentContainer.searchAll()
            // },
            showAreaCount() {
                if (this.selectedRangeStore[this.targetType]) {
                    let selectedArea
                    selectedArea = area(this.selectedRangeStore[this.targetType])
                    this.parentContainer.info = false
                    if(selectedArea > 0){
                        this.parentContainer.infoText = this.$vuetify.lang.t('$vuetify.search.main.selectedArea') + (selectedArea/1000000).toFixed(2) + this.$vuetify.lang.t('$vuetify.search.main.squareKilometer')
                    }else {
                        if(this.selectedRangeStore[this.targetType].type == 'Point'){
                            this.parentContainer.infoText =  this.$vuetify.lang.t('$vuetify.search.main.selectedPoint') + ' <' + this.selectedRangeStore[this.targetType].coordinates[1].toFixed(2) +' , '+ this.selectedRangeStore[this.targetType].coordinates[0].toFixed(2) + '>'
                        }
                        if(this.selectedRangeStore[this.targetType].type == 'LineString'){
                            this.parentContainer.infoText =  this.$vuetify.lang.t('$vuetify.search.main.selectedLine') +  lineDistance(this.selectedRangeStore[this.targetType]).toFixed(2) + 'km'
                        }
                        if(this.selectedRangeStore[this.targetType].type == 'FeatureCollection'){
                            this.parentContainer.infoText = this.$vuetify.lang.t('$vuetify.search.main.selectedFile')
                        }
                    }
                    setTimeout(()=>{this.parentContainer.info = true},1)
                } else {
                    this.parentContainer.info = false
                }
            },
            disableDraw() {
                // this.parentContainer.$refs.map.mapObject.fire('draw:canceled');
                // this.markerDraw.disable();
                this.parentContainer.$refs.map.mapObject.fire('draw:canceled');
                this.polygonDraw.disable();
                console.log('test')
            },
            draw(val){
                this.$store.state.search.selectedRangeStore['draw'] = ''
                this.parentContainer.showSearchRangeSelector =false// 绘制时隐藏此界面
                switch (val) {
                    case 0:
                        this.markerDraw.enable()
                        break;
                    case 1:
                        this.rectangleDraw.enable()
                        break;
                    case 2:
                        this.polygonDraw.enable()
                        break;
                    case 3:
                        this.polylineDraw.enable()
                        break;

                }
                this.parentContainer.$refs.map.mapObject.on(L.Draw.Event.CREATED, (e)=>{
                    this.$store.state.search.selectedRangeStore['draw']  = e.layer.toGeoJSON().geometry
                    // this.$set(this.$store.state.search.selectedRangeStore, 'draw', e.layer.toGeoJSON().geometry)
                    this.showAreaCount()
                    this.parentContainer.showSearchRangeSelector = true
                    // this.parentContainer.searchAll()
                    this.parentContainer.$refs.map.mapObject.off(L.Draw.Event.CREATED)
                });
            },
            fitView() {
                if(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType]!==''){
                    if(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType].type !== 'Point'){
                        this.parentContainer.$refs.map.mapObject.fitBounds(L.geoJSON(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType]).getBounds())
                    } else {
                        this.parentContainer.$refs.map.mapObject.setView([this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType].coordinates[1], this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType].coordinates[0]])
                    }
                    this.drawFinished = true
                }
            },
            setPointListArea() {
                let geoJson = {
                    type: "Polygon",
                    coordinates:[[]]
                }
                this.pointList.forEach((item)=>{
                    if(item.lng!==''){
                        geoJson.coordinates[0].push([item.lng, item.lat])
                    }
                })
                geoJson.coordinates[0].push([this.pointList[0].lng, this.pointList[0].lat])
                this.$store.state.search.selectedRangeStore['coordinatesArray'] = geoJson
            },
            addPoint (){
                this.pointList.push({lat:'',lng:''})
            },
            removePoint (val){
                this.pointList.splice(val,1)
            },
            setLatLngArea1 () {
                if(this.valid1){
                    var centerLongitude1 =  parseFloat (this.centerLongitude1);
                    var centerLatitude1 =  parseFloat (this.centerLatitude1);
                    var centerLength = parseFloat (this.centerLength);
                    var centerWidth = parseFloat (this.centerWidth);
                    var source = point([centerLongitude1, centerLatitude1]);

                    var P1 = destination(point(destination(source, centerWidth, 0).geometry.coordinates), centerLength, -90).geometry.coordinates;
                    var P2 = destination(point(destination(source, centerWidth, 0).geometry.coordinates), centerLength, 90).geometry.coordinates;
                    var P3 = destination(point(destination(source, centerWidth, 180).geometry.coordinates), centerLength, 90).geometry.coordinates;
                    var P4 = destination(point(destination(source, centerWidth, 180).geometry.coordinates), centerLength, -90).geometry.coordinates;
                    this.$store.state.search.selectedRangeStore['rectangle'] = {
                        type: "Polygon",
                        coordinates:[
                            [
                                P1,
                                P2,
                                P3,
                                P4,
                                P1
                            ]
                        ]
                    }
                }
            },
            setLatLngArea2 () {
                if(this.valid2) {
                    var centerLongitude2 = parseFloat(this.centerLongitude2);
                    var centerLatitude2 = parseFloat(this.centerLatitude2);
                    var centerRadius = parseFloat(this.centerRadius);
                    var center = [centerLongitude2, centerLatitude2];
                    this.$store.state.search.selectedRangeStore['circle'] = circle(center, centerRadius, 64, 'kilometers').geometry;
                }
            },
            clearAll () {
                this.chooseItem = 0
                this.drawFinished = false
                this.$store.state.search.longitude = ''
                this.$store.state.search.latitude = ''
                if(this.$store.state.search.targetType == 'point') {
                    this.$refs.point.lngDegree = '0'
                    this.$refs.point.lngMinute = '0'
                    this.$refs.point.lngSeconds = '0'
                    this.$refs.point.latDegree = '0'
                    this.$refs.point.latMinute = '0'
                    this.$refs.point.latSeconds = '0'
                }
                this.chinaProvinceNow = ''
                if(this.$store.state.search.targetType == 'china') {
                    this.$refs.chinaProvince.lazySearch = ''
                }
                this.countryNow = ''
                if(this.$store.state.search.targetType == 'world') {
                    this.$refs.country.lazySearch = ''
                }
                this.leftUpLongitude = ''
                this.leftUpLatitude = ''
                this.rightDownLongitude = ''
                this.rightDownLatitude = ''
                this.centerLongitude2 = ''
                this.centerLatitude2 = ''
                this.centerRadius = ''
                this.centerLongitude1 = ''
                this.centerLatitude1 = ''
                this.centerLength = ''
                this.centerWidth = ''
                this.pointList = [
                    {lat:'',lng:''},
                    {lat:'',lng:''},
                    {lat:'',lng:''},
                ]
                this.$store.state.search.selectedRangeStore = {
                    upload:'',
                    china:'',
                    world:'',
                    point:'',
                    draw:'',
                    coordinatesArray:'',
                    rectangle:'',
                    circle:''
                }
            }
        },
        computed: {
            lang() {
                return this.$vuetify.lang.current
            },
            targetType() {
                return this.$store.state.search.targetType
            },
            selectedRangeStore() {
                return this.$store.state.search.selectedRangeStore
            },
            rules() {
                return {
                    required: value => !!value || this.$vuetify.lang.t('$vuetify.search.rangeSelector.required'),
                    lng: value => value>-180 && value<180 ||  this.$vuetify.lang.t('$vuetify.search.rangeSelector.illegal'),
                    lat: value => value>-90 && value<90 ||  this.$vuetify.lang.t('$vuetify.search.rangeSelector.illegal'),
                    gt0: value => value > 0 ||  this.$vuetify.lang.t('$vuetify.search.rangeSelector.gt0')
                }
            }
        },
        watch: {
            lang(val) {
                this.setTipByLang()
            },
            targetType(val) {
                switch (val) {
                    // case 'point':
                    //     this.type = 1
                    //     break;
                    case 'draw':
                        this.type = 0
                        break;
                    // case 'coordinatesArray':
                    //     this.type = 2
                    //     break;
                    // case 'rectangle':
                    //     this.type = 2
                    //     break;
                    // case 'circle':
                    //     this.type = 2
                    //     break;
                    case 'china':
                        this.type = 1
                        break;
                    case 'world':
                        this.type = 1
                        break;
                    case 'upload':
                        this.type = 2
                        break;
                }
                this.showAreaCount()
                // this.fitView()
                this.dmsShow = false
            },
            selectedRangeStore: {
                handler(){
                    this.showAreaCount()
                    this.fitView()
                },
                deep: true
            },
            pointList: {
                handler(){
                    setTimeout(()=>{if (this.valid){this.setPointListArea()}},1)
                },
                deep: true
            },
            areaType () {
                switch (this.areaType){
                    case 0:
                        this.setPointListArea()
                        break
                    case 1:
                        this.setLatLngArea1()
                        break
                    case 2:
                        this.setLatLngArea2()
                        break
                }
            },
            valid1 () {
                if (this.centerLongitude1){
                    this.setLatLngArea1()
                }
            },
            centerLongitude1 () {
                if(this.centerLongitude1<180 && this.centerLongitude1>-180 && this.centerLongitude1!=='')
                {
                    this.setLatLngArea1()
                }
            },
            centerLatitude1 () {
                if(this.centerLatitude1<90 && this.centerLatitude1>-90 && this.centerLatitude1!=='')
                {
                    this.setLatLngArea1()
                }
            },
            centerLength () {
                if(this.centerLength>0 && this.centerLength!=='')
                {
                    this.setLatLngArea1()
                }
            },
            centerWidth () {
                if(this.centerWidth>0 && this.centerWidth!=='')
                {
                    this.setLatLngArea1()
                }
            },
            valid2 () {
                if (this.centerLongitude2){
                    this.setLatLngArea2()
                }
            },
            centerLongitude2 () {
                if(this.centerLongitude2<180 && this.centerLongitude2>-180 && this.centerLongitude2!=='')
                {
                    this.setLatLngArea2()
                }
            },
            centerLatitude2 () {
                if(this.centerLatitude2<90 && this.centerLatitude2>-90 && this.centerLatitude2!=='')
                {
                    this.setLatLngArea2()
                }
            },
            centerRadius () {
                if(this.centerRadius>0 && this.centerRadius!=='')
                {
                    this.setLatLngArea2()
                }
            },
            chinaProvinceNow () {
                this.chinaCityNow = ''
                this.chinaCountyNow = ''
                this.chinaCityItems = []
                this.chinaCountyItems = []
                this.$refs.chinaCity.lazySearch = ''
                this.$refs.chinaCounty.lazySearch = ''
                if (this.chinaProvinceNow !== ''){
                    this.axios.get('/accessapi/searchService/Area/id=' + this.chinaProvinceNow)
                        .then((res) => {
                            this.chinaCityItems = res.data.data
                        })
                    this.$store.state.search.selectedRangeStore['china'] = JSON.parse(this.chinaProvinceItems.find((x)=>{return x.areaId === this.chinaProvinceNow}).areaGeojson)
                }
            },
            chinaCityNow () {
                this.chinaCountyNow = ''
                this.chinaCountyItems = []
                this.$refs.chinaCounty.lazySearch = ''
                if (this.chinaCityNow !== '')
                {
                    this.axios.get('/accessapi/searchService/Area/id=' + this.chinaCityNow)
                        .then((res) => {
                            this.chinaCountyItems = res.data.data
                        })
                    this.$store.state.search.selectedRangeStore['china'] = JSON.parse(this.chinaCityItems.find((x)=>{return x.areaId === this.chinaCityNow}).areaGeojson)
                }
            },
            chinaCountyNow () {
                if (this.chinaCountyNow !== '') {
                    this.$store.state.search.selectedRangeStore['china'] = JSON.parse(this.chinaCountyItems.find((x) => {return x.areaId === this.chinaCountyNow}).areaGeojson)
                }
            },
            countryNow () {
                this.$store.state.search.selectedRangeStore['world'] = JSON.parse(this.countryNow)
            },
        },
        mounted() {
            this.$store.state.search.targetType = 'draw'
            // this.parentContainer = this.findRealParent(this.$parent);
            this.parentContainer = this.Search;
            this.axios.get('/accessapi/searchService/Area/id=-1').then((res) => {
                this.chinaProvinceItems = res.data.data
            })
            this.axios.get("/accessapi/searchService/countryList").then((res) => {
                this.countryItems = res.data.data
            })

            this.setTipByLang()
            // window.addEventListener('keyup', (e) => {
            //     if (this.targetType === 'draw'){
            //         if (e.keyCode === 27) {
            //             this.drawPolygon()
            //         }
            //     }
            // })
        },
    }
</script>

<style scoped>
::v-deep .row{
    display: flex;
    align-items: center;
    justify-content: center;
}
.chooseBar{
    border-radius: 4px;
    width:550px;
    height:45px;
    position: absolute;
    left: 390px;
    top: 12px;
    background-color: #2A2A2A;
    display: flex;
    align-items: center;
    justify-content: center;
}
.barItem{
    width: 136px;
    height: 45px;
    position:relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.barIcon{
    width: 15px;
    height: 15px;
    position:relative;
}
.barText{
    position:relative;
    margin-left: 10px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #F5F5F6;
    line-height: 20px;
    text-align: center;
    font-style: normal;
}
.barTextChoose{
    position:relative;
    margin-left: 10px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #618FFE;
    line-height: 20px;
    text-align: center;
    font-style: normal;
}
.deliverLine{
    width: 1px;
    height: 33px;
    border: 1px dashed #ABABAB;
}
.regionBox{
    border-radius: 4px;
    width:403px;
    height:50px;
    position: absolute;
    left: 464px;
    top: 68px;
    background-color: #2A2A2A;
    display: flex;
    align-items: center;
    justify-content: center;
}
.uploadBox{
    width:341px;
    height:119px;
    position: absolute;
    left: 495px;
    top: 233px;
}
.clearBtn{
    width:92px;
    height:42px;
    position: absolute;
    left: 619px;
    top: 553px;
    background-color: #2A2A2A;
    border-radius: 4px;
    cursor: pointer;
}
.clearBtnText{
    position: absolute;
    left: 40px;
    top: 12px;
    width: 32px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #F5F5F6;
    line-height: 20px;
    text-align: center;
    font-style: normal;
}
</style>
